<ce-container>
    <ce-empty-state type="unauthorized" actionLabel="Go to login" actionHref="/2.0/auth/login">
        <h1 ce-empty-state-title>Unauthorized</h1>
        <p ce-empty-state-description>You don't have the permissions to access this page.</p>
    </ce-empty-state>
</ce-container>
